import NextImage from 'next/image';
import ContactOfficeContactLink from './ContactOfficeContactLink';
import type { ContactOfficeCard as ContactOfficeCardType } from '@/types/contact';

interface ContactOfficeCardProps {
  office: ContactOfficeCardType;
  cardIconUrl: string | null;
  emailIconUrl: string | null;
  phoneIconUrl: string | null;
}

export default function ContactOfficeCard({
  office,
  cardIconUrl,
  emailIconUrl,
  phoneIconUrl,
}: ContactOfficeCardProps) {
  const officeName = office.officeName?.trim() || '';
  const officeAddress = office.officeAddress?.trim();

  return (
    <div
      data-office-card
      className="group flex flex-col rounded-2xl border border-black/[0.06] bg-white p-5 shadow-[0_2px_12px_rgba(0,0,0,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_32px_rgba(0,0,0,0.1)]"
      style={{ opacity: 0 }}
    >
      <div className="mb-3 flex items-start justify-between gap-2">
        <h3 className="text-[13.5px] font-bold text-[#E31E24]">{officeName}</h3>
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#E31E24]/8 text-[#E31E24]">
          {cardIconUrl ? (
            <NextImage
              src={cardIconUrl}
              alt=""
              width={13}
              height={13}
              className="h-[13px] w-[13px]"
            />
          ) : (
            <span className="h-[13px] w-[13px]" aria-hidden />
          )}
        </span>
      </div>

      <div className="mb-3 h-px bg-black/[0.06]" />

      {officeAddress ? (
        <div
          className="mb-3 flex-1 text-[12.5px] leading-relaxed text-black/55"
          dangerouslySetInnerHTML={{ __html: officeAddress }}
        />
      ) : null}

      {(office.contactItem ?? []).map((item) => (
        <ContactOfficeContactLink
          key={item.id}
          item={item}
          emailIconUrl={emailIconUrl}
          phoneIconUrl={phoneIconUrl}
        />
      ))}
    </div>
  );
}
